export default {
  getGenres: (state) => state.genres,
  getSchools: (state) => state.schools,
  isSchoolsLoading: (state) => state.schoolsLoading,
  getSchoolsError: (state) => state.schoolsError,
  getEvents: (state) => state.events,
  getEventsTotal: (state) => state.eventsTotal,
  isEventsLoading: (state) => state.eventsLoading,
  getEventSearch: (state) => state.eventSearch,
  isEventSearchLoading: (state) => state.eventSearchLoading,
  getEventSearchError: (state) => state.eventSearchError,
  getTodayClasses: (state) => state.todayClasses,
  getCurrentSchool: (state) => state.currentSchool,
  getCurrentEvent: (state) => state.currentEvent,
  getCurrentOrganizer: (state) => state.currentOrganizer,
  isDetailLoading: (state) => state.detailLoading,
  getDetailError: (state) => state.detailError,
};
